<template>
  <v-skeleton-loader v-if="isLoading" type="list-item-three-line" />
  <v-list-item v-else>
    <slot name="icon"></slot>

    <v-list-item-content>
      <v-list-item-title class="text-truncate">
        <div style="display: flex">
          <div>
            <a v-if="hasOpenDetailListener" @click.stop="emitOpenDetail">
              {{ item.companyName }}
            </a>
            <span v-else> {{ item.companyName }} </span>
            <span v-if="item.externalId">({{ item.externalId }})</span>
          </div>
        </div>
      </v-list-item-title>
      <v-list-item-subtitle v-if="!small" class="text-xs">
        <span v-if="item.isFleet">
          <v-chip x-small class="mr-1">
            {{ $t("objects.company.isFleet") }}
          </v-chip>
        </span>
        <span v-if="item.services">
          <v-chip x-small v-for="service of item.services" :key="'service-enum' + service" class="mr-1">
            {{ $t(`enums.CompanyServiceEnum.${service}`) }}
          </v-chip>
        </span>
        <span>
          <v-skeleton-loader v-if="loadingProject" type="chip" />
          <v-chip v-else-if="group" x-small class="mr-1" @click.stop="goToCompanyGroupCustomView">
            {{ $t("company.group") }}: {{ group.title }}
            <v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
          </v-chip>
        </span>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <slot name="action"></slot>
    </v-list-item-action>
  </v-list-item>
</template>

<script lang="ts">
import { CompanyGoToHelper } from "@/lib/utility/company.go-to-helper";
import { CompanyGroup, ICompanyGroup } from "@/models/company-group.entity";
import { ICompany } from "@/models/company.entity";
import { CompanyGroupModule } from "@/store/modules/company-group.store";
import { Component, Prop, Watch } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";

@Component({
  components: {},
  filters: {}
})
export default class RefsCompany extends BaseRef<ICompany> implements IRefDetail<ICompany> {
  @Prop()
  item!: ICompany;

  @Prop()
  small!: boolean;

  @Prop({ default: true })
  showCompany!: boolean;

  @Prop()
  confirmable!: boolean;

  group: ICompanyGroup | null = null;

  loadingProject = false;

  get isLoading() {
    return this.item?.loading;
  }

  async mounted() {
    await this.setGroup();
  }

  async goToDetail() {
    const partnerId = this.item.partnerId;
    const companyId = this.item.id;
    const newTab = false;

    new CompanyGoToHelper(this.$router).goToCompanyDetail({ companyId, partnerId, newTab });
  }

  @Watch("item.groupId")
  async setGroup() {
    try {
      if (this.item.groupId) {
        this.loadingProject = true;
        let group = CompanyGroupModule.maps.id.get(this.item.groupId)[0];
        if (!group) {
          group = await new CompanyGroup({ partnerId: this.item.partnerId, id: this.item.groupId }).fetch();
        }
        this.group = group;
      }
    } catch (e) {
      this.$log.error(e);
    } finally {
      this.loadingProject = false;
    }
  }

  goToCompanyGroupCustomView() {
    if (!this.item.groupId) return;

    new CompanyGoToHelper(this.$router).goToCompanyGroupCustomView({
      partnerId: this.item.partnerId,
      companyGroupId: this.item.groupId,
      viewId: "0",
      newTab: true
    });
  }
}
</script>
<style lang="css" scoped>
.hoverCurserMouse :hover {
  cursor: pointer;
}
</style>
